$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Placeholder scripts
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search Website')
  $('#mobileSearchInput').val('')

  $('header .emailSignup a').text("")

  // TOGGLE
  $('.mobile-nav-toggle').append(`
    <div></div>
    <div></div>
    <div></div>
    `)

  // Tickets & Deals
  $('.ticket').text("Buy Tickets")

  $('.footer-navigation ').each(function () {
    $(this).find('.footer-navigation__separator').text('-')
  })




  // Footer
  $('.sticky-footer .emailSignup .emailSignupText').text('Get Updates!')
  $('.sticky-footer .emailSignup .emailInputField input').attr('placeholder', 'Enter Email Address')
  $('.sticky-footer .emailSignup .emailInputField input').val('')
  $('.sticky-footer .emailInputSubmit a').text('subscribe')

  $('.sticky-footer .emailSignup ').append('<div class="wrap-sign-up"></div>')
  $('.sticky-footer .emailInputField').appendTo('.wrap-sign-up')
  $('.sticky-footer .emailInputSubmit').appendTo('.wrap-sign-up')


  //Footer Nav items

  let childCount = $('.footer-navigation').children().length;
  let groupOne = $('.footer-navigation').children('li').slice(0, (childCount - 5));
  let groupTwo = $('.footer-navigation').children('li').slice(-5);
  groupOne.wrapAll('<div class="colOne"></div>');
  groupTwo.wrapAll('<div class="colTwo"></div>');




  $(window).load(function () {
    setTimeout(() => {
      $('#siteInfoBannerWidget').clone().appendTo('#mainFeatureSlide .banner-mobile')
    }, 1000);
  })
});

